/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_ImportingInputs */

const en_zotero_browser_importing = /** @type {(inputs: Zotero_Browser_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing...`)
};

const es_zotero_browser_importing = /** @type {(inputs: Zotero_Browser_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando...`)
};

/**
* | output |
* | --- |
* | "Importing..." |
*
* @param {Zotero_Browser_ImportingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_importing = /** @type {((inputs?: Zotero_Browser_ImportingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_ImportingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_importing(inputs)
	return en_zotero_browser_importing(inputs)
});